/* eslint-env browser */
import createHttpDriver from '@k-ramel/driver-http'
import { router } from '@k-redux-router/react-k-ramel'
import routes from './router'

export { router }

export default {
  window: { getDriver: () => window },
  http: createHttpDriver(),
  router: router({ routes }),
}
